<template>
    <div class="row">
        <div class="col-md-6">
            <div class="alert alert-danger" role="alert" v-if="loadError">
                Неполучилось загрузить данные. Попробуйте перезагрузить страницу.
            </div>
            <h5>IML</h5>
            <div class="form-group">
                <template v-for="(el, i) in fields">
                    <label v-bind:key="'f_'+i" for="account">Логин ({{ i }}):</label>
                    <div v-bind:key="'a_'+i" class="input-group mb-2">
                        <input type="text" class="form-control" v-model="el.login">
                        <div class="input-group-append">
                            <button v-on:click="removeField(i)" class="btn btn-outline-danger" type="button"><i class="fas fa-times"></i></button>
                        </div>
                    </div>
                    <label v-bind:key="'la_'+i" for="secure">Пароль ({{ i }}):</label>
                    <input v-bind:key="'s_'+i" type="text" class="form-control mb-4" id="secure" v-model="el.password">
                </template>
            </div>
            <button type="button" class="btn btn-primary" v-on:click="save">Сохранить</button>
            <button v-on:click="addField" type="button" class="btn btn-outline-primary ml-2"><i class="fas fa-plus"></i></button>
            <div v-if="isHelp">
                <div v-for="(el, i) in alert_s" v-bind:key="'as_'+i" class="row mb-2 alert" v-bind:class="{'alert-success': el.type === 'success', 'alert-danger': el.type === 'error', 'alert-warning': el.type === 'warning'}" role="alert">Логин/Пароль ({{ el.id }}): {{ el.status }}</div>
            </div>
        </div>
        <div class="d-flex flex-column flex-grow col-md-6">
            <div class="row d-flex flex-row justify-content-end">
                <i v-on:click="isHelp = !isHelp" class="fas fa-question help-icon"></i>
            </div>
            <div v-if="!isHelp">
                <div v-for="(el, i) in alert_s" v-bind:key="'al_'+i" class="row mb-2 alert" v-bind:class="{'alert-success': el.type === 'success', 'alert-danger': el.type === 'error', 'alert-warning': el.type === 'warning'}" role="alert">Логин/Пароль ({{ el.id }}): {{ el.status }}</div>
            </div>
            <div v-if="isHelp" class="row sp-c">
                <p>
                    Логин и пароль от вашего личного кабинета.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import urls from '@/lib/urls'
import common from '@/lib/common'

export default {
  name: 'IML',
  data: function () {
    return {
      alert_s: [],
      alert_e: [],
      domain: '',
      loadError: false,
      fields: [{
        login: '',
        password: ''
      }],
      isHelp: false,
    }
  },
  async created() {
    const self = this

    axios.get(urls.getSettings, await common.setAuthorizationHeader()).then((response) => {
      if (Array.isArray(response.data.iml)) {
        if(response.data.iml.length === 0){
          self.isHelp = true
        } else{
          self.fields = response.data.iml
        }
      } else {
        self.fields[0].login = response.data.iml.login
        self.fields[0].password = response.data.iml.password
      }
    }).catch(error => {
      let errorParsed = common.errorQueryHandler(error)

      if (errorParsed.type === 'unauthorization') {
        common.queryRefreshToken(error).then(response => {
          if (Array.isArray(response.data.iml)) {
            if(response.data.iml.length === 0){
              self.isHelp = true
            } else{
              self.fields = response.data.iml
            }
          } else {
            self.fields[0].login = response.data.iml.login
            self.fields[0].password = response.data.iml.password
          }
        }).catch(err => {
          self.loadError = true
          console.log('Error - ' + error)
        })
      } else if (errorParsed.type === 'some') {
        self.loadError = true
        console.log('Error - ' + error)
      } else {
        self.loadError = true
        console.log('Error - ' + error)
      }
    })
  },
  methods: {
    removeField: function (i) {
      if (this.fields.length == 1) {
        this.fields[0].login = ''
        this.fields[0].password = ''
      } else {
        this.fields.splice(i, 1)
      }
    },
    addField: function () {
      let el = {
        login: '',
        password: ''
      }
      this.fields.push(el)
    },
    save: async function () {
      const self = this

      this.alert_s = ''
      this.alert_e = ''
      this.alert_s_show = false
      this.alert_e_show = false
      if (this.fields.length < 1) {
        this.alert_s = []
        let el = {
          id: 0,
          type: 'warning',
          status: 'Добавьте поля!'
        }
        this.alert_s.push(el)
      } else if (this.fields[0].login != '' && this.fields[0].login != ' ' && this.fields[0].password != '' && this.fields[0].password != ' ') {
        this.fields = this.fields.filter(n => n.login && n.password)

        let postData = {
          iml: this.fields
        }

        axios.post(urls.saveSettings, postData, await common.setAuthorizationHeader()).then(response => {
          let s = response.data.iml.length
          self.alert_e = []
          self.alert_s = []
          for (let i = 0; i < s; i++) {
            if (response.data.iml[i].status.match("Ошибка")) {
              let el = {
                id: i,
                type: 'error',
                status: response.data.iml[i].status
              }
              self.alert_s.push(el)
            } else {
              let el = {
                id: i,
                type: 'success',
                status: response.data.iml[i].status
              }
              self.alert_s.push(el)
            }
          }
        }).catch(error => {
          let errorParsed = common.errorQueryHandler(error)

          if (errorParsed.type === 'unauthorization') {
            common.queryRefreshToken(error).then(response => {
              let s = response.data.iml.length
              self.alert_e = []
              self.alert_s = []
              for (let i = 0; i < s; i++) {
                if (response.data.iml[i].status.match("Ошибка")) {
                  let el = {
                    id: i,
                    type: 'error',
                    status: response.data.iml[i].status
                  }
                  self.alert_s.push(el)
                } else {
                  let el = {
                    id: i,
                    type: 'success',
                    status: response.data.iml[i].status
                  }
                  self.alert_s.push(el)
                }
              }
            }).catch(err => {
              self.alert_s = []
              let el = {
                id: 0,
                type: 'error',
                status: err
              }
              self.alert_s.push(el)
            })
          } else if (errorParsed.type === 'some') {
            self.alert_s = []
            let el = {
              id: 0,
              type: 'error',
              status: error.error.response.data.errorMessage
            }
            self.alert_s.push(el)
          } else {
            self.alert_s = []
            let el = {
              id: 0,
              type: 'error',
              status: error
            }
            self.alert_s.push(el)
          }
        })
      } else {
        this.alert_s = []
        let el = {
          id: 0,
          type: 'warning',
          status: 'Заполните все поля!'
        }
        this.alert_s.push(el)
      }
    }
  },
}
</script>
<style scope>

</style>
